import { TariffOption, HeadlineWithInfo } from './structured-content-models';

export class BausteinHeaderConfig {
  tariffOption: TariffOption;
  headlineWithInfo: HeadlineWithInfo;
}
